import { IGetAllProductsRequest, IForceSyncRequest } from '../../types/api/request/productsrequest';
import {
  IGetAllProductsResponse,
  IGetLatestSyncStatusResponse,
  ISyncLastModifiedResponse,
  IGetSyncRunsResponse,
  IGetSyncRunResponse,
  IGetRunQueueResponse,
  IForceSyncResponse,
  IGetSyncHistoryResponse,
} from '../../types/api/response/productsresponse';
import axiosClient from '../axiosClient';
import { ProductsEndpoints } from '../endpoints/products';

export const ProductsService = {
  async getAllProducts(payload: IGetAllProductsRequest): Promise<IGetAllProductsResponse> {
    const params = payload
      ? `?page=${payload?.page}&size=${payload?.size}${payload.keyword ? `&keyword=${payload.keyword}` : ''}`
      : ``;
    const res = await axiosClient.get<IGetAllProductsResponse>(
      `${ProductsEndpoints.GET_ALL_PRODUCTS}${params}`,
    );
    return res.data;
  },

  async getLatestSyncStatus(): Promise<IGetLatestSyncStatusResponse> {
    const res = await axiosClient.get<IGetLatestSyncStatusResponse>(
      ProductsEndpoints.GET_LATEST_SYNC_STATUS,
    );
    return res.data;
  },

  async syncLastModified(): Promise<ISyncLastModifiedResponse> {
    const res = await axiosClient.post<ISyncLastModifiedResponse>(ProductsEndpoints.START_SYNC);
    return res.data;
  },

  async getSyncRuns(page = 0, size = 20): Promise<IGetSyncRunsResponse> {
    const res = await axiosClient.get<IGetSyncRunsResponse>(
      `${ProductsEndpoints.GET_SYNC_RUNS}?page=${page}&size=${size}`,
    );
    return res.data;
  },

  async getSyncRun(runId: number): Promise<IGetSyncRunResponse> {
    const res = await axiosClient.get<IGetSyncRunResponse>(ProductsEndpoints.GET_SYNC_RUN(runId));
    return res.data;
  },

  async getRunQueue(
    runId: number,
    status?: string,
    page = 0,
    size = 100,
  ): Promise<IGetRunQueueResponse> {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (status) params.set('status', status);
    const res = await axiosClient.get<IGetRunQueueResponse>(
      `${ProductsEndpoints.GET_RUN_QUEUE(runId)}?${params}`,
    );
    return res.data;
  },

  async forceSync(skus: string[]): Promise<IForceSyncResponse> {
    const payload: IForceSyncRequest = { skus };
    const res = await axiosClient.post<IForceSyncResponse>(ProductsEndpoints.FORCE_SYNC, payload);
    return res.data;
  },

  async getSyncHistory(sku: string, page = 0, size = 20): Promise<IGetSyncHistoryResponse> {
    const params = new URLSearchParams({ sku, page: String(page), size: String(size) });
    const res = await axiosClient.get<IGetSyncHistoryResponse>(
      `${ProductsEndpoints.GET_SYNC_HISTORY}?${params}`,
    );
    return res.data;
  },
};
